// Conteúdo dos QR Codes de formulário.
//
// O QR aponta para um *deep link* que abre o formulário direto no app operacional
// (BPF-OFFLINE, Expo Router, scheme `bpfoffline`) — não mais para uma página web.
//
// A base vem de REACT_APP_BPF_APP_LINK_URL:
//   - "bpfoffline://"                  → custom scheme (default; sem infra, mas o QR
//                                        não faz nada se o app não estiver instalado)
//   - "https://app.digitalbpf.com.br"  → App Link / Universal Link, se o domínio
//                                        servir assetlinks.json + AASA e o app
//                                        reivindicar o domínio. Mesmo QR, abre o app
//                                        quando instalado e a web quando não.
// Trocar de um para o outro é só mudar a env — o formato do link não muda.

const APP_LINK_BASE = process.env.REACT_APP_BPF_APP_LINK_URL || "bpfoffline://";

// Rota que o app deve tratar: `<base>/form?form_id=&domain=&identifier=`
export const FORM_LINK_PATH = "form";

/**
 * Monta o deep link de um formulário.
 * @param {{ formId: number|string, domain: string, identifier?: string|null }} params
 * @returns {string}
 */
export function buildFormDeepLink({ formId, domain, identifier }) {
  const base = APP_LINK_BASE.endsWith("/") ? APP_LINK_BASE : `${APP_LINK_BASE}/`;
  const query = new URLSearchParams({
    form_id: String(formId),
    domain: domain || "",
  });

  // Identificador é opcional: sem ele o app abre o formulário em branco.
  if (identifier) {
    query.append("identifier", identifier);
  }

  return `${base}${FORM_LINK_PATH}?${query.toString()}`;
}

// Tenant (subdomínio) do host atual — mesma regra usada no resto do app.
export function currentDomain() {
  return window.location.hostname.split(".")[0];
}
